import { useEffect } from 'react';
import { SITE_ORIGIN } from '../config/store';

// Keeps <title>, the meta description and the canonical link in sync with the
// active route. Each page declares its own metadata, so navigating between
// routes always leaves the document describing the page you are actually on.
//
// Note on scope: this runs on the client, after the bundle executes. It is
// correct for browser tabs, history entries and crawlers that execute JS, but
// it cannot help scrapers that only read the initial HTML response. Giving
// those the right tags would require prerendering or server-side rendering,
// which this static build does not do.
function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function upsertCanonical(path) {
  if (!path) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', new URL(path, `${SITE_ORIGIN}/`).toString());
}

export default function usePageMetadata({ title, description, canonicalPath }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta('description', description);
    upsertCanonical(canonicalPath);
  }, [title, description, canonicalPath]);
}
